import * as utils from "../assets/scripts/utils";
import Event from "../assets/scripts/base/Event";
import cookie from "../assets/scripts/base/Cookie";
import defaultHead from "../assets/images/defaultHead.png"
import { useState, useEffect, useRef, useCallback } from 'react';
import * as otherState from "./state";
import { BaseService } from "@/service";
import { message } from "antd";
import { checkResult } from "@/common";
import { platformDic } from "@/dic";
import i18nZh from '../i18n/zh.json'
import i18nEn from '../i18n/en.json'

const theme = localStorage.getItem("theme") || "#2d80d6";
const localCode = localStorage.getItem("localCode") || "";

const region = utils.getUrlParam("region");

let hostname = window.location.hostname;
const IS_DEV = hostname === "localhost";
if (IS_DEV) hostname = "ww2.techchina.org.cn"

const LANG_ZH = "zh";
const LANG_EN = "en";
const LANG = LANG_ZH;
const IS_ZH = LANG === LANG_ZH;
const IS_EN = LANG === LANG_EN;

const PLATFORM = platformDic.THTT.value

if (PLATFORM === "HZ") document.title = "\"Capital HOME Program\" Cloud Exhibition Hall Digital Platform";

const i18n = IS_ZH ? i18nZh : i18nEn;

const store = {
    // 初始 state
    state: {
        region,
        PLATFORM,
        IS_REGION: Boolean(region),
        fetchLoading: false,
        // tocken
        token: cookie.get("csrfToken"),
        // 主题色
        theme: theme,
        // 本地标示
        localCode,
        // 默认头像
        defaultHead,
        LANG,
        IS_ZH,
        IS_EN,
        i18n,
        IS_DS: false,
        ROOT: `http://${hostname}/demo`,
        MAIN_ROOT: `http://www.techchina.org.cn`,
        wxUser: {},
        loginBack: "",
        pageBack: "",

        userState: {
            subscribe: false,
        },

        // 模态框
        modal: {},

        // APP_ID
        $_REGION: region ? {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_workstation", where: { area_code: region }, leftJoin: {
                    table: "thtt_china",
                    on: "thtt_workstation.area_code = thtt_china.id",
                    columns: ["name as regionName"]
                },
            },
            format: res => {
                var data = res.data.result[0];
                if (!data) {
                    message.warn("工作站未建立！");
                    return {}
                }
                if (data.regionName === "柏乡县") data.regionName = "柏乡";
                return data;
            }
        } : {},
        $_APP_ID: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_setting", where: { id: "wx_app_id" } },
            format: res => res.data.result[0].value
        },
        // 成果部联系方式
        $_RESULT_CONTACT: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_setting", where: { id: "result-contacts" } },
            format: res => res.data.result[0].value
        },
        // 成果部联系方式
        $_DEMAND_CONTACT: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_setting", where: { id: "demand-contacts" } },
            format: res => res.data.result[0].value
        },
        // 项目部联系方式
        $_PROJECT_CONTACT: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_setting", where: { id: "project-contacts" } },
            format: res => res.data.result[0].value
        },
        // 上传服务IP端口
        $_UPLOAD_SERVER_HOST: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_setting", where: { id: "upload-server-host" } },
            format: res => res.data.result[0].value
        },
        // 分中心
        $_ORG_CENTER: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_organization", columns: "organization_id AS value,name AS label", where: { type: 3 } },
            format: res => res.data.result
        },
        // 行业
        $_INDUSTRY: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_industry_v2", columns: "name,code,is_leaf", where: { depth: 1 } },
            format: res => res.data.result.map(({ code, name, is_leaf }) => ({ label: name, value: code, isLeaf: !!is_leaf }))
        },
        // 需求活动类型
        $_DEMAND_ACTIVITY_TYPE: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_", columns: "title,id" },
            format: res => res.data.result.map(({ title, id }) => ({ label: title, value: id }))
        },
        // 机构群
        $_ORG_GROUPS: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_organization_group",
                columns: "name,id",
                where: { is_delete: 0 },
                order: ["add_time DESC"],
                process: {
                    name: "items",
                    key: "id",
                    targetKey: "org_group_id",
                    params: {
                        table: "thtt_organization_group_item",
                        leftJoin: {
                            table: "thtt_organization",
                            on: "thtt_organization_group_item.org_id = thtt_organization.organization_id",
                            columns: ["name"]
                        }
                    }
                }
            },
            format: res => res.data.result
        },
        // 机构群
        $_ORG_GROUPS_DETAIL: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_organization_group",
                columns: "name,id",
                where: { is_delete: 0 },
                order: ["add_time DESC"],
                process: {
                    name: "items",
                    key: "id",
                    targetKey: "org_group_id",
                    params: {
                        table: "thtt_organization_group_item",
                        leftJoin: [
                            {
                                table: "thtt_organization",
                                on: "thtt_organization_group_item.org_id = thtt_organization.organization_id",
                                columns: ["name"]
                            },
                            {
                                table: "thtt_user",
                                on: "thtt_organization.user_id = thtt_user.user_id",
                                columns: JSON.stringify(["name AS adminUserName", "tel AS adminUserTel", "openid"])
                            },
                        ]
                    }
                }
            },
            format: res => res.data.result
        },
        // 领域
        $_SCOPE: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_scope", columns: "id,pid,name,sort,level", where: { is_delete: 0, stage: 1 } },
            format: res => {
                const scopes = res.data.result;
                const level1 = scopes.filter(val => val.level == 1);
                const formatScope = [];
                level1.forEach(val => {
                    const { id } = val;
                    val.childs = scopes.filter(val => val.pid === id).map(({ name, id, pid }) => ({ label: name, value: id, pid }));
                    formatScope.push({
                        label: val.name,
                        value: val.id,
                        childs: val.childs
                    })
                })
                return formatScope;
            }
        },
        // 国家
        $_COUNTRY: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_area", columns: "id,cn_name,en_name", where: { level: 2 } },
            format: res => res.data.result.map(({ id, cn_name, en_name }) => ({ label: cn_name, en_name, value: id }))
        },
        // 地区（中国）
        $_REGIONS: {
            unload: true,
            service: BaseService.list,
            params: { table: "thtt_china", columns: "id,name,level", where: { pid: 0 } },
            format: res => res.data.result.map(({ id, name, level }) => ({ label: name, value: id, isLeaf: false, level }))
        },
        // 领域-技术属性
        $_SCOPE_TECHNOLOGY: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_scope", columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names", where: { is_delete: 0, level: 1, code: "technology" }, process: {
                    name: "childs",
                    key: "value",
                    targetKey: "pid",
                    params: {
                        table: "thtt_scope",
                        columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                        where: { is_delete: 0, stage: 1 },
                    }
                }
            },
            format: res => (res.data.result[0] || { childs: [] }).childs
        },
        $_SCOPE_TECHNOLOGY_VO: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_scope", columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names", where: { is_delete: 0, level: 1, code: "technology" },
                process: {
                    name: "childs",
                    key: "value",
                    targetKey: "pid",
                    params: {
                        table: "thtt_scope",
                        columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                        where: { is_delete: 0, stage: 1 },
                        process: {
                            name: "childs",
                            key: "value",
                            targetKey: "pid",
                            params: {
                                table: "thtt_scope",
                                columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                                where: { is_delete: 0, stage: 1 }
                            }
                        }
                    }
                }
            },
            format: res => res.data.result[0]
        },
        // 领域-产品形态
        $_SCOPE_FORM: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_scope", columns: "id AS value,pid,name AS label,name_en,name_en,sort,level,patent_classify_ids,patent_classify_names", where: { is_delete: 0, level: 1, code: "form" }, process: {
                    name: "childs",
                    key: "value",
                    targetKey: "pid",
                    params: {
                        table: "thtt_scope",
                        columns: "id AS value,pid,name AS label,name_en,name_en,sort,level,patent_classify_ids,patent_classify_names",
                        where: { is_delete: 0, stage: 1 },
                    }
                }
            },
            format: res => (res.data.result[0] || { childs: [] }).childs
        },
        $_SCOPE_FORM_VO: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_scope", columns: "id AS value,pid,name AS label,name_en,name_en,sort,level,patent_classify_ids,patent_classify_names", where: { is_delete: 0, level: 1, code: "form" }, process: {
                    name: "childs",
                    key: "value",
                    targetKey: "pid",
                    params: {
                        table: "thtt_scope",
                        columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                        where: { is_delete: 0, stage: 1 },
                        process: {
                            name: "childs",
                            key: "value",
                            targetKey: "pid",
                            params: {
                                table: "thtt_scope",
                                columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                                where: { is_delete: 0, stage: 1 }
                            }
                        }
                    }
                }
            },
            format: res => res.data.result && res.data.result[0]
        },
        // 领域-产业方向
        $_SCOPE_DIRECTION: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_scope", columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names", where: { is_delete: 0, level: 1, code: "direction" }, process: {
                    name: "childs",
                    key: "value",
                    targetKey: "pid",
                    params: {
                        table: "thtt_scope",
                        columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                        where: { is_delete: 0, stage: 1 },
                    }
                }
            },
            format: res => (res.data.result[0] || { childs: [] }).childs
        },
        $_SCOPE_DIRECTION_VO: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_scope", columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names", where: { is_delete: 0, level: 1, code: "direction" },
                process: {
                    name: "childs",
                    key: "value",
                    targetKey: "pid",
                    params: {
                        table: "thtt_scope",
                        columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                        where: { is_delete: 0, stage: 1 },
                        process: {
                            name: "childs",
                            key: "value",
                            targetKey: "pid",
                            params: {
                                table: "thtt_scope",
                                columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                                where: { is_delete: 0, stage: 1 }
                            }
                        }
                    }
                }
            },
            format: res => res.data.result && res.data.result[0]
        },
        // 领域-应用场景
        $_SCOPE_SCENE: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_scope", columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names", where: { is_delete: 0, level: 1, code: "scene" }, process: {
                    name: "childs",
                    key: "value",
                    targetKey: "pid",
                    params: {
                        table: "thtt_scope",
                        columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                        where: { is_delete: 0, stage: 1 },
                    }
                }
            },
            format: res => (res.data.result[0] || { childs: [] }).childs
        },
        $_SCOPE_SCENE_VO: {
            unload: true,
            service: BaseService.list,
            params: {
                table: "thtt_scope", columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names", where: { is_delete: 0, level: 1, code: "scene" }, process: {
                    name: "childs",
                    key: "value",
                    targetKey: "pid",
                    params: {
                        table: "thtt_scope",
                        columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                        where: { is_delete: 0, stage: 1 },
                        process: {
                            name: "childs",
                            key: "value",
                            targetKey: "pid",
                            params: {
                                table: "thtt_scope",
                                columns: "id AS value,pid,name AS label,name_en,sort,level,patent_classify_ids,patent_classify_names",
                                where: { is_delete: 0, stage: 1 }
                            }
                        }
                    }
                }
            },
            format: res => res.data.result && res.data.result[0]
        },

        ...otherState
    },
    _storeEvent: new Event(),
    // 所有被监听的 state 路径
    _watchPaths: [],
}

export const state = store.state;

export const handler = {
    login: (user) => {
        setState("user.info", user);
        setState("user.IS_LOGIN", true);

        BaseService.list({
            table: "thtt_user",
            columns: "user_id,authority,visible_province,visible_city,visible_county,org_type,activity_identity",
            where: { user_id: user.user_id },
            process: {
                name: "orgs",
                key: "user_id",
                targetKey: "user_id",
                params: {
                    table: "thtt_organization",
                    columns: "organization_id,name"
                }
            }
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result[0];
            user.authority = data.authority;
            user.orgs = data.orgs;
            user.org_type = data.org_type;
            user.visible_province = data.visible_province;
            user.visible_city = data.visible_city;
            user.visible_county = data.visible_county;
            user.activity_identity=data.activity_identity;
            setState("user.info", user);
            sessionStorage.setItem("user", JSON.stringify(user));

            // 查询可见地区名称
            BaseService.list({
                table: "thtt_china",
                where: {
                    id: [data.visible_province, data.visible_city, data.visible_county].filter(v => v)
                }
            }).then(res => {
                if (!checkResult(res)) return;
                const names = res.data.result.map(({ name }) => name);
                setState("user.info.visibleName", names);
                user.visibleName = names;
                sessionStorage.setItem("user", JSON.stringify(user));
            })
        })
    },
    logout: () => {
        sessionStorage.removeItem("user");
        setState("user.info", {});
        setState("user.IS_LOGIN", false);
        localStorage.removeItem("login");
        window.location.href = '/'
    },
    logoutIsefc: () => {
        sessionStorage.removeItem("user");
        setState("user.info", {});
        setState("user.IS_LOGIN", false);
        localStorage.removeItem("login");
        window.location.href = '/#/isefc'
    },
    onLoadRegion: async (treeNode) => {
        const item = treeNode.last();
        if (item.children) {
            return;
        }
        const pid = item.value;
        const res = await BaseService.list({
            table: "thtt_china",
            columns: "id,name,level",
            where: { pid }
        })
        item.children = res.data.result.map(({ id, name, level }) => ({ label: name, value: id, isLeaf: level === 3, level }));
        setState("$_REGIONS", store.state.$_REGIONS);
    },
    onLoadRegionLevel2: async (treeNode) => {
        const item = treeNode.last();
        if (item.children || item.level === 2) {
            return;
        }
        const pid = item.value;
        const res = await BaseService.list({
            table: "thtt_china",
            columns: "id,name,level",
            where: { pid }
        })
        item.children = res.data.result.map(({ id, name, level }) => ({ label: name, value: id, isLeaf: level === 3, level }));
        setState("$_REGIONS", store.state.$_REGIONS);
    }
}

export const setState = (path, value) => {
    utils.oset(store.state, path, value);

    if (process.env.NODE_ENV == "development") {
        const styles = 'color:#fff;background:#6739b6;padding:5px 10px;';

        // console.log()
        // console.log("%c- update state START ------------", styles)
        // console.log(path, value)
        // console.log(utils.deepCopy(store.state))
        // console.log("%c- update state END ------------", styles)
    }

    store._watchPaths.forEach(val => {
        if (path.includes(val)) store._storeEvent.emit({ value, state: store.state }, val)
    })
}

export const setTheme = color => {
    window.less.modifyVars({
        '@primary-color': color
    })
    setState("theme", color);
    localStorage.setItem("theme", color);
}

// 监听全局 state 变化
export const useWatchState = paths => {

    paths.forEach(val => store._watchPaths.includes(val) ? '' : store._watchPaths.push(val))

    const [props, setProps] = useState(utils.ogets(store.state, paths).map((val, i) => {
        // if (paths[i] === "$_ORG_CATEGORY") {
        //     console.log(val)
        //     console.log(val && val.unload ? undefined : val)
        // }
        return [(val && val.unload) ? undefined : val, value => setState(paths[i], value), paths[i]]
    }));

    function handlePropsChange({ value, state }) {
        setProps(utils.ogets(state, paths).map((val, i) => [val, value => setState(paths[i], value), paths[i]]));
    }

    useEffect(() => {
        paths.forEach(val => store._storeEvent.on(handlePropsChange, val))
        return () => {
            paths.forEach(val => store._storeEvent.off(val, handlePropsChange))
        }
    })
    // 过滤出需要自动获取的变量
    const autoLoads = paths.filter(path => path.includes("$_"))
    autoLoads.forEach(path => {
        // 先查看是否已经获取到
        const data = utils.oget(store.state, path);
        if (!data || !data.unload || data.loading) return;

        // 避免重复查询
        setState(path, {
            ...data,
            loading: true
        });

        data.service(data.params).then(res => {
            const value = data.format(res);
            setState(path, value);
        })
    })

    return props;
}

let HSState = {};

function useHState(value, name, setValue) {

    let _value = value;

    const ctl = {
        set: value => {
            _value = value;
            setValue(value)
        },
        get: () => _value
    }

    if (HSState[name]) return HSState[name];

    HSState[name] = ctl;
    return ctl
}

export function useHandlerState(value) {

    const [_value, setValue] = useState(value);
    const [name] = useState(utils.getRandomStr());

    const [ctl] = useState(useHState(value, name, setValue));

    useEffect(() => {
        ctl.set(_value)
    }, [_value])

    return [_value, setValue, ctl]
}

// 分页
export const useService = ({ service, path, format, params = {}, before, after }) => {

    const [data, setData] = useState(utils.oget(store.state, path));

    const send = async (_params) => {
        if (before && !before()) return;
        try {

            let result = await service(_params || params);
            if (!result || !result.data || result.data.status !== 200) return;

            if (format) result = format(result);
            if (after) after(result);
            setData(result);

            // 是否需要保存到全局的 state 中
            if (path) setState(path, result);
        } catch (error) {
            message.error(error)
        }
    }

    useEffect(() => {
        send()
    }, [])

    return [
        data, { set: setData, refresh: send }
    ]
}

/**
 * 分页
 * @param {Any} condition 执行条件
 * @param {Function} before 之前前判断
 * @param {Boolean} cache 当 cache 等于 true 时必须保证返回结果都是数组
 */
export const usePage = ({ atonce = true, cache = false, service, path, format, index = 1, size = 10, params = {}, names = ['pageIndex', 'pageSize'], before, after, condition }) => {

    let [data, setData] = useState(path ? utils.oget(store.state, path) : []);
    let _params = { ...params };
    const setParams = params => _params = { ...params }
    const [current, setCurrent] = useState(1);
    const [total, setTotal] = useState(1);
    const [totalSize, setTotalSize] = useState(1);
    let [_index, setIndex] = useState(index);

    const send = async () => {
        if (before && !before()) return;
        let result = await service({ [names[0]]: _index, [names[1]]: size, ..._params });
        if (!result || !result.data || result.data.status !== 200) return;

        // 更新总页数
        setCurrent(result.data.result.current)
        setTotal(result.data.result.pages)
        setTotalSize(result.data.result.total)

        if (format) result = format(result);
        const _data = cache ? data.concat(result) : result;
        if (after) after(_data);
        setData(_data);

        // 是否需要保存到全局的 state 中
        if (path) setState(path, result);
    }

    const go = (index, params) => {
        if (params) {
            setParams({ ...params });
            _params = params;
        }

        // 超出页数范围（不应该加，如果查询条件变了，上一次的总页数将作废）
        // if (index <= 0 || index > total) return console.error("超出页数范围");

        setIndex(index);
        _index = index;
        send();
    };
    const up = () => {
        if (_index <= 1) return message.warn(i18n.page.one); setIndex(index);
        _index = _index - 1;
        setIndex(_index)
        send();
    }
    const next = () => {
        if (_index >= total) return message.warn(i18n.page.over);
        _index = _index + 1;
        setIndex(_index)
        send();
    }
    const hasNext = () => _index < total;
    const clear = () => {
        data = [];
        setData([]);
        return control;
    }

    const control = { go, up, next, clear, refresh: send };

    // 初始执行
    useEffect(() => {
        if (atonce) send()
    }, []);

    return [
        data, {
            go, up, next, clear, refresh: send, hasNext, onPage: _index, set: setData, total, totalSize, current,
            params: _params,
            rewriteParams: setParams,
            setParams: (path, value) => {
                utils.oset(_params, path, value);
                setParams({ ..._params });
            }
        }
    ]
}

export const useModal = (modals = []) => {

    const [modalControl] = useState(modals.map(val => {

        const hide = (() => setState("modal." + val + ".show", false))
            .after(() => {
                setState("modal." + val, {
                    show: false,
                    hide
                })
            }, 500);

        // 1. 创建 modal 对应的 state
        if (!store.state.modal[val]) setState("modal." + val, {
            show: false,
            hide
        })

        // 2. 返回控制函数
        return {
            show: props => setState("modal." + val, { show: true, hide, ...props }),
            hide: hide.after(() => setState("modal." + val, { show: false, hide }), 500),
        }
    }));

    return modalControl;
}

export const useDebounce = function (fn, delay, dep = []) {
    const { current } = useRef({ fn, timer: null });
    useEffect(function () {
        current.fn = fn;
    }, [fn]);
    return useCallback(function f(...args) {
        if (current.timer) {
            clearTimeout(current.timer)
        }
        current.timer = setTimeout(() => {
            current.fn.call(this, ...args);
        }, delay);
    }, dep);
}